import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

// STANDARD UNIT
export const SpecificGravity: ConvertableUnit = {
  shortLabel: "SpGr",
  label: "Specific Gravity",
  toStandardUnit: sg => sg,
  toThisUnit: sg => sg
};

export const API: ConvertableUnit = {
  label: "API",
  toStandardUnit: api => 141.5 / (api + 131.5),
  toThisUnit: sg => 141.5 / sg - 131.5
};

export const KilogramsPerCubicMeter: ConvertableUnit = {
  label: "kg/m³",
  toStandardUnit: kgpm3 => kgpm3 / 1000,
  toThisUnit: sg => sg * 1000
};

export const PoundsPerCubicFoot: ConvertableUnit = {
  label: "lb/ft³",
  toStandardUnit: lbmpft3 => lbmpft3 / 62.428,
  toThisUnit: sg => sg * 62.428
};

export const GasPoundsPerCubicFoot: ConvertableUnit = {
  label: "lb/ft³ (gas)",
  toStandardUnit: lbmpft3 => lbmpft3 / 0.0752,
  toThisUnit: sg => sg * 0.0752
};

const unitList = [
  SpecificGravity,
  API,
  KilogramsPerCubicMeter,
  PoundsPerCubicFoot,
  GasPoundsPerCubicFoot
];

export const DensityUnits = {
  SpecificGravity,
  API,
  KilogramsPerCubicMeter,
  PoundsPerCubicFoot,
  GasPoundsPerCubicFoot,
  options: buildOptions(unitList)
};
